import { useEffect } from 'react';

import type { ModelSubscription } from '@app/api/Subscriptions';

interface UseSubscriptionModalEffectsProps {
  subscriptionToFill: ModelSubscription | null;
  fillForm: (subscription: ModelSubscription) => void;
  loadSubscription: () => Promise<void>;
}

export const useSubscriptionModalEffects = ({
  subscriptionToFill,
  fillForm,
  loadSubscription,
}: UseSubscriptionModalEffectsProps): void => {
  useEffect(() => {
    loadSubscription();
  }, [loadSubscription]);

  useEffect(() => {
    if (subscriptionToFill) {
      fillForm(subscriptionToFill);
    }
  }, [fillForm, subscriptionToFill]);
};
